import { render, staticRenderFns } from "./sortorder.vue?vue&type=template&id=3d8676ab&scoped=true"
import script from "./sortorder.vue?vue&type=script&lang=js"
export * from "./sortorder.vue?vue&type=script&lang=js"
import style0 from "./sortorder.vue?vue&type=style&index=0&id=3d8676ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8676ab",
  null
  
)

export default component.exports